// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
interface Action {
  type: string;
  payload?: LoggedUserResponse | any;
}

import { LoadingStatus } from '@app/core/models';

export enum LoggedUserActionType {
  LOGGED_USER_LOADING = 'LOGGED_USER_LOADING',
  LOGGED_USER_COMPLETE = 'LOGGED_USER_COMPLETE',
  LOGGED_USER_FAILED = 'LOGGED_USER_FAILED',
  LOGGED_USER_CLEAN = 'LOGGED_USER_CLEAN'
}

export class LoggedUserLoading implements Action {
  type = LoggedUserActionType.LOGGED_USER_LOADING;
}

export class LoggedUserFailed implements Action {
  type = LoggedUserActionType.LOGGED_USER_FAILED;
}

export class LoggedUserClean implements Action {
  type = LoggedUserActionType.LOGGED_USER_CLEAN;
}

export class LoggedUserLoadComplete implements Action {
  type = LoggedUserActionType.LOGGED_USER_COMPLETE;
  constructor(public payload: LoggedUserResponse) {}
}

export type LoggedUserActions = LoggedUserLoading | LoggedUserFailed | LoggedUserClean | LoggedUserLoadComplete;

// Response of /user
export interface LoggedUserResponse {
  id: string;
  sf_id: string;
  user_name: string;
  first_name: string;
  last_name: string;
  email: string;
  account_id: string;
  account_name: string;
  roles?: UserRole[];
}

// Response of /users/-/rolescopes
export interface UserRole {
  role_id: string;
  role_name: string;
  scopes: UserRoleScope[];
}
// Response of /users/-/rolescopes
export interface UserRoleScope {
  scope_id: string;
  object_type_id: number;
  object_type_name: string;
  object_id: string;
  object_name: string;
}

export type LoggedUserState = LoggerUserReducer | null;

export interface LoggerUserReducer {
  data?: LoggedUserResponse | null;
  status?: LoadingStatus;
}

export function loggedUserReducer(state: LoggedUserState = null, action: Action) {
  switch (action.type) {
    case LoggedUserActionType.LOGGED_USER_LOADING:
      return {
        status: LoadingStatus.LOADING
      };
    case LoggedUserActionType.LOGGED_USER_FAILED:
      return {
        status: LoadingStatus.LOAD_FAILED
      };
    case LoggedUserActionType.LOGGED_USER_CLEAN:
      return null;
    case LoggedUserActionType.LOGGED_USER_COMPLETE:
      return {
        data: action.payload,
        status: LoadingStatus.LOAD_COMPLETE
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/state/logged-user/index.ts